import React from 'react'

import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Grid } from '@mui/material'
import { useParams } from 'react-router-dom'

import { FormTextField } from 'components/input'
import { withForm } from 'decorators/withForm'
import { useCreateCampaignNote } from 'hooks/useCampaignNotes'
import { useCurrentUserId } from 'hooks/useCurrentUserId'
import { campaignNoteValidator } from 'validators/campaign-notes'

type CampaignNoteCreateProps = {
  handleSubmit: (...args: any[]) => any
  open: boolean
  onClose: (...args: any[]) => any
}

const CampaignNoteCreate = ({ handleSubmit, open, onClose }: CampaignNoteCreateProps) => {
  const { id: campaignId } = useParams()
  const createCampaignNote = useCreateCampaignNote()

  const onSubmit = (values: any) => {
    createCampaignNote.mutate({ campaignId, payload: values })
    onClose()
  }

  return (
    <Dialog onClose={onClose} open={open}>
      <form onSubmit={handleSubmit(onSubmit)}>
        <DialogTitle>Create new note</DialogTitle>
        <DialogContent>
          <Grid container spacing={2} style={{ width: 500 }}>
            <Grid size={{ sm: 12 }}>
              <FormTextField label="Text" maxRows={5} multiline name="note" />
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={onClose}>Close</Button>
          <Button color="primary" type="submit">
            Submit
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  )
}

const CampaignNoteCreateForm = withForm({
  form: 'campaignNoteCreate',
  validate: campaignNoteValidator,
})(CampaignNoteCreate)

// initialValues (the note's author) comes from redux app.user.id; inject it as a prop so the RHF adapter seeds it as a default.
const CampaignNoteCreateWithUser = (props: any) => {
  const userId = useCurrentUserId()
  return <CampaignNoteCreateForm {...props} initialValues={{ userId }} />
}

export default CampaignNoteCreateWithUser
